export const getDetailedErrorMessage = (error: any, defaultMessage: string = 'An unexpected error occurred') => {
  // Network error
  if (!error.response) {
    return 'Network error: Please check your internet connection and try again.';
  }

  const { status, data } = error.response;
  
  // Server errors (5xx)
  if (status >= 500) {
    return `Server error (${status}): The server is experiencing issues. Please try again later.`;
  }
  
  // Client errors (4xx)
  if (status >= 400) {
    let message = defaultMessage;
    
    if (data?.message) {
      if (typeof data.message === 'string') {
        message = data.message;
      } else if (typeof data.message === 'object') {
        message = Object.values(data.message).join(', ');
      }
    }
    
    // Add status code for debugging
    return `${message} (Error ${status})`;
  }
  
  return defaultMessage;
};